export const DEFAULT_SCOREBOARD_THEME = "modern-dark";
export const SCOREBOARD_THEMES = [
  {
    id: "modern-dark",
    name: "Modern Dark",
    description: "Your current scoreboard",
    tone: "The original",
    surface: "#252525",
    ink: "#ffffff",
    accent: "#ff9500",
  },
  {
    id: "light",
    name: "Light Theme",
    description: "Clean & Minimal",
    tone: "Clear by day",
    surface: "#f5f6f8",
    ink: "#14181f",
    accent: "#c72538",
  },
  {
    id: "neon",
    name: "Neon Accent",
    description: "Modern & Vibrant",
    tone: "After hours",
    surface: "#130c25",
    ink: "#faf6ff",
    accent: "#d878ff",
  },
  {
    id: "premium",
    name: "Premium",
    description: "Elegant",
    tone: "Understated gold",
    surface: "#111213",
    ink: "#f7f7f5",
    accent: "#e7ab43",
  },
];
export const normalizeScoreboardTheme = (value) =>
  SCOREBOARD_THEMES.some((theme) => theme.id === value)
    ? value
    : DEFAULT_SCOREBOARD_THEME;
export const scoreboardThemeName = (value) =>
  SCOREBOARD_THEMES.find(
    (theme) => theme.id === normalizeScoreboardTheme(value)
  ).name;
